import React, { useContext, useState } from "react";

import "../styles/DesktopSiteView.css";
import "../styles/siteDetails.css";

import { Nav, NavItem, NavLink } from "reactstrap";
import SiteMap from "../components/SiteMap";
import DocumentView from "./DocumentView";
import SiteInventory from "./SiteInventory";
import SiteContacts from "./SiteContacts";
import SiteDataSheet from "./SiteDataSheet";
import { RenderContext } from "../App";
import SiteImages from "./SiteImages";
import SiteSpec from "./SiteSpec";

export default function DesktopSiteView({ site, user }) {
	const { renderControlledComponent, renderedElements } =
		useContext(RenderContext);

	const [activeTab, setActiveTab] = useState(
		renderedElements?.includes("site-tab-data-sheet")
			? "data-sheet"
			: "contacts",
	);

	const changeTab = (event) => {
		setActiveTab(event.target.getAttribute("tab-id"));
	};

	const getTabContent = () => {
		switch (activeTab) {
			case "data-sheet":
				return <SiteDataSheet site={site} />;
			case "contacts":
				return <SiteContacts selectedSite={site} />;
			case "docs":
				return <DocumentView site={site} user={user} />;
			case "inv":
				return <SiteInventory site={site} />;
			case "images":
				return <SiteImages site={site} />;
			case "spec":
				return <SiteSpec site={site} />;
			default:
				return null;
		}
	};

	const getSiteName = () => {
		if (site === undefined) return null;
		return (
			site.name +
			(site.name2 === undefined ||
			site.name2 === null ||
			site.name2 === ""
				? ""
				: " - " + site.name2)
		);
	};

	const getSiteAbbr = () => {
		if (site === undefined) return null;
		return site.aqmetAbbr;
	};

	return (
		<div id="desktop-site-view">
			<SiteMap site={site} />
			<div id="site-details-info-wrapper">
				<span id="site-details-sitename">{getSiteName()}</span>
				<span id="site-details-siteabbr">{getSiteAbbr()}</span>
				<Nav id="desktop-site-view-tabs" tabs>
					<SiteDetailsTab
						tabId="data-sheet"
						tabText="Data Sheet"
						activeTab={activeTab}
						changeTab={changeTab}
						isControlled={true}
					/>
					<SiteDetailsTab
						tabId="contacts"
						tabText="Contacts"
						activeTab={activeTab}
						changeTab={changeTab}
					/>
					<SiteDetailsTab
						tabId="docs"
						tabText="Documents"
						activeTab={activeTab}
						changeTab={changeTab}
					/>
					<SiteDetailsTab
						tabId="images"
						tabText="Images"
						activeTab={activeTab}
						changeTab={changeTab}
					/>
					<SiteDetailsTab
						tabId="spec"
						tabText="Specifications"
						activeTab={activeTab}
						changeTab={changeTab}
					/>
					<SiteDetailsTab
						tabId="inv"
						tabText="Inventory"
						activeTab={activeTab}
						changeTab={changeTab}
					/>
				</Nav>
				<div id="desktop-site-view-content">{getTabContent()}</div>
			</div>
		</div>
	);
}

function SiteDetailsTab({
	tabId,
	activeTab,
	changeTab,
	tabText,
	isControlled = false,
}) {
	const { renderControlledComponent } = useContext(RenderContext);

	if (isControlled) {
		return renderControlledComponent(
			<NavItem className="site-tab" id={"site-tab-" + tabId}>
				<NavLink
					tab-id={tabId}
					active={activeTab === tabId}
					onClick={changeTab}
				>
					{tabText}
				</NavLink>
			</NavItem>,
		);
	} else {
		return (
			<NavItem className="site-tab" id={"site-tab-" + tabId}>
				<NavLink
					tab-id={tabId}
					active={activeTab === tabId}
					onClick={changeTab}
				>
					{tabText}
				</NavLink>
			</NavItem>
		);
	}
}
